module.exports = __webpack_public_path__ + "assets/img/pg.32a73041.png";